export default {
  sales: null,
  sale: null,
  error: false,
  errorMessage: "",
  successMessage: "",
  success: false,
};
